import type { TableCellAdapter } from 'ui/components/HourlyDataTable/HourlyDataTable.types'
import type { CellColumn } from '../BidInputTable.types'
import { getCellKey, parseCellKey } from '../helpers/BidInputTable.helpers'

export function makeBidTableAdapter(visibleCellColumns: CellColumn[], rowCount: number): TableCellAdapter {
  return {
    columnCount: visibleCellColumns.length,
    rowCount,
    getCoordinate(cellKey) {
      const parsed = parseCellKey(cellKey)
      if (!parsed || parsed.hourIndex < 0 || parsed.hourIndex >= rowCount) {
        return null
      }
      const columnIndex = visibleCellColumns.findIndex(
        (col) =>
          col.positionId === parsed.positionId && col.tagId === parsed.tagId && col.direction === parsed.direction
      )
      return columnIndex === -1 ? null : { rowIndex: parsed.hourIndex, columnIndex }
    },
    getCellKey({ rowIndex: hourIndex, columnIndex }) {
      const col = visibleCellColumns[columnIndex]
      return col ? getCellKey(hourIndex, col.positionId, col.tagId, col.direction) : null
    },
  }
}
